'use client'
import { assertPackageVersion } from '@dynamic-labs/assert-package-version';
import { version } from '../package.js';
import './lib/shared/utils/functions/getInitialUrl/getInitialUrl.js';
export { VERSION } from './version.js';
export { getWallets } from './lib/views/WalletList/data.js';
export { getAuthToken } from './lib/utils/functions/getAuthToken/getAuthToken.js';
export { getMinAuthToken } from './lib/utils/functions/getMinAuthToken/getMinAuthToken.js';
export { DynamicContext, DynamicContextProvider } from './lib/context/DynamicContext/DynamicContext.js';
export { ErrorBoundary } from './lib/context/ErrorBoundary/ErrorBoundary.js';
export { ErrorBoundaryExclude } from './lib/context/ErrorBoundary/ErrorBoundaryExclude.js';
export { ErrorBoundaryInclude } from './lib/context/ErrorBoundary/ErrorBoundaryInclude.js';
export { useDynamicContext } from './lib/context/DynamicContext/useDynamicContext/useDynamicContext.js';
import 'react';
export { useDynamicScopes } from './lib/utils/hooks/useDynamicScopes/useDynamicScopes.js';
export { useUserWallets } from './lib/context/UserWalletsContext/UserWalletsContext.js';
import 'react/jsx-runtime';
export { classNames } from './lib/utils/functions/classNames/classNames.js';
import './lib/components/Accordion/components/AccordionItem/AccordionItem.js';
import './lib/components/Alert/Alert.js';
export { useDynamicEvents } from './lib/utils/hooks/events/useDynamicEvents/useDynamicEvents.js';
export { useWalletConnectorEvent } from './lib/utils/hooks/events/useWalletConnectorEvent/useWalletConnectorEvent.js';
export { useAuthenticateConnectedUser } from './lib/utils/hooks/useAuthenticateConnectedUser/useAuthenticateConnectedUser.js';
export { DynamicJwtFromJSON } from '@dynamic-labs/sdk-api-core';
import './lib/shared/logger.js';
export { getChainIcon } from './lib/shared/utils/functions/chain/getChainIcon.js';
export { getChainDisplayName } from './lib/shared/utils/functions/chain/getChainDisplayName.js';
export { createWallet } from './lib/shared/utils/functions/wallet/createWallet.js';
export { getValueByKey } from './lib/shared/utils/functions/getValueByKey/index.js';
import '@dynamic-labs/utils';
import './lib/utils/constants/colors.js';
import './lib/utils/constants/values.js';
import '@dynamic-labs/wallet-connector-core';
export { useLocalStorage } from './lib/shared/utils/hooks/useLocalStorage/useLocalStorage.js';
export { useOnClickOutside } from './lib/shared/utils/hooks/useOnClickOutside/index.js';
export { ReactComponent as ArrowLeftIcon } from './lib/shared/assets/arrow-left.js';
export { ReactComponent as ArrowRightIcon } from './lib/shared/assets/arrow-right.js';
export { ReactComponent as CheckCircleIcon } from './lib/shared/assets/check-circle.js';
export { ReactComponent as CheckIcon } from './lib/shared/assets/check.js';
export { ReactComponent as ChevronLeftIcon } from './lib/shared/assets/chevron-left.js';
export { ReactComponent as CloseIcon } from './lib/shared/assets/close.js';
export { ReactComponent as CopyIcon } from './lib/shared/assets/copy.js';
export { ReactComponent as EmbeddedWalletIcon } from './lib/shared/assets/embedded-wallet-icon.js';
export { ReactComponent as ErrorIcon } from './lib/shared/assets/error.js';
export { ReactComponent as ExternalLinkIcon } from './lib/shared/assets/externalLink.js';
export { ReactComponent as EyeIcon } from './lib/shared/assets/footer-eye-icon.js';
export { ReactComponent as InfoIcon } from './lib/shared/assets/footer-info-icon.js';
export { ReactComponent as IPhoneFaceId } from './lib/shared/assets/iphone-face-id.js';
export { ReactComponent as IPhoneTouchId } from './lib/shared/assets/iphone-touch-id.js';
export { ReactComponent as LogoutIcon } from './lib/shared/assets/logout.js';
export { ReactComponent as PencilIcon } from './lib/shared/assets/pencil.js';
export { ReactComponent as SpinnerIcon } from './lib/shared/assets/spinner.js';
export { ReactComponent as ArrowIcon } from './lib/shared/assets/stroke.js';
import '@dynamic-labs/iconic';
import './lib/context/ViewContext/ViewContext.js';
import './lib/shared/consts/index.js';
import '../_virtual/_tslib.js';
import 'react-dom';
export { publicDynamicEvents as dynamicEvents } from './lib/events/dynamicEvents.js';
export { sdkApi as apiClient } from './lib/data/api/api.js';
import './lib/store/state/user/user.js';
import './lib/store/state/projectSettings/projectSettings.js';
import './lib/locale/locale.js';
import '@dynamic-labs/multi-wallet';
import 'react-international-phone';
export { mergeNetworks } from './lib/utils/functions/mergeNetworks/mergeNetworks.js';
export { overrideNetworkRpcUrl } from './lib/utils/functions/overrideNetworkRpcUrl/overrideNetworkRpcUrl.js';
import './lib/store/state/nonce/nonce.js';
export { isAuthenticatedWithAWallet } from './lib/utils/functions/isAuthenticatedWithAWallet/isAuthenticatedWithAWallet.js';
import './lib/store/state/dynamicContextProps/dynamicContextProps.js';
import './lib/store/state/primaryWalletId/primaryWalletId.js';
import './lib/utils/functions/compareChains/compareChains.js';
import './lib/context/ThemeContext/ThemeContext.js';
export { useIsLoggedIn } from './lib/utils/hooks/useIsLoggedIn/useIsLoggedIn.js';
import './lib/context/VerificationContext/VerificationContext.js';
export { useOtpVerificationRequest } from './lib/utils/hooks/authenticationHooks/useOtpVerificationRequest/useOtpVerificationRequest.js';
import './lib/utils/hooks/useUserUpdateRequest/useUpdateUser/userFieldsSchema.js';
export { usePasskeyRecovery } from './lib/utils/hooks/usePasskeyRecovery/usePasskeyRecovery.js';
export { useEVMTransactionSimulation } from './lib/utils/hooks/useTransactionSimulation/classes/useEVMTransactionSimulation.js';
export { useSVMTransactionSimulation } from './lib/utils/hooks/useTransactionSimulation/classes/useSVMTransactionSimulation.js';
export { useSocialAccounts } from './lib/utils/hooks/useSocialAccounts/useSocialAccounts.js';
import 'yup';
export { MockContextProvider } from './lib/context/MockContext/MockContext.js';
import './lib/views/CollectUserDataView/useFields.js';
export { useUserUpdateRequest } from './lib/utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import './lib/context/UserFieldEditorContext/UserFieldEditorContext.js';
import './lib/context/FieldsStateContext/FieldsStateContext.js';
export { useRpcProviders } from './lib/utils/hooks/useRpcProviders/useRpcProviders.js';
import './lib/store/state/loadingAndLifecycle.js';
import '@dynamic-labs/store';
import './lib/context/AccessDeniedContext/AccessDeniedContext.js';
import './lib/context/AccountExistsContext/AccountExistsContext.js';
import './lib/context/ErrorContext/ErrorContext.js';
import '@dynamic-labs/wallet-book';
import './lib/store/state/walletOptions/walletOptions.js';
export { useWalletItemActions } from './lib/utils/hooks/useWalletItemActions/useWalletItemActions.js';
import 'react-i18next';
export { useSmartWallets } from './lib/utils/hooks/useSmartWallets/useSmartWallets.js';
import './lib/context/FooterAnimationContext/index.js';
export { ShadowDOM } from './lib/components/ShadowDOM/ShadowDOM.js';
import './lib/components/Transition/ZoomTransition/ZoomTransition.js';
import './lib/components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import './lib/components/Transition/OpacityTransition/OpacityTransition.js';
import './lib/components/OverlayCardBase/OverlayCardTarget/OverlayCardTarget.js';
import './lib/context/WalletGroupContext/WalletGroupContext.js';
import './lib/widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import 'react-focus-lock';
import './lib/context/LoadingContext/LoadingContext.js';
export { useMultiWalletPromptState } from './lib/widgets/DynamicWidget/hooks/useMultiWalletPromptState/useMultiWalletPromptState.js';
import './lib/context/WalletContext/WalletContext.js';
import './lib/context/CaptchaContext/CaptchaContext.js';
export { DynamicWidgetContextProvider } from './lib/widgets/DynamicWidget/context/DynamicWidgetContext.js';
import './lib/components/IconButton/IconButton.js';
import './lib/components/MenuList/Dropdown/Dropdown.js';
export { useSwitchWallet } from './lib/utils/hooks/useSwitchWallet/useSwitchWallet.js';
import 'formik';
import './lib/utils/hooks/useSubdomainCheck/useSubdomainCheck.js';
import './lib/store/state/sendBalances.js';
import './lib/components/Input/Input.js';
import './lib/components/OverlayCard/OverlayCard.js';
import './lib/views/TransactionConfirmationView/TransactionConfirmationView.js';
import './lib/context/PasskeyContext/PasskeyContext.js';
import './lib/widgets/DynamicWidget/views/ManagePasskeysWidgetView/PasskeyCard/PasskeyCard.js';
export { useEmbeddedReveal } from './lib/utils/hooks/useEmbeddedReveal/useEmbeddedReveal.js';
export { useEmbeddedWalletAuthenticator } from './lib/utils/hooks/useEmbeddedWalletAuthenticator/useEmbeddedWalletAuthenticator.js';
import './lib/context/OnrampContext/OnrampContext.js';
export { FilterAndSortWallets, FilterBridgeChainsName, FilterChain, FilterWallets, RemoveWallets, SortWallets, UniswapFilter } from './lib/utils/functions/walletFilters/index.js';
export { useFundWithWallet } from './lib/utils/hooks/useFundWithWallet/useFundWithWallet.js';
import 'qrcode';
import './lib/widgets/DynamicWidget/views/ReceiveWalletFunds/ReceiveWalletFunds.js';
export { NoQrNotInstalledView } from './lib/views/NoQrNotInstalledView/NoQrNotInstalledView.js';
export { CollectUserDataView } from './lib/views/CollectUserDataView/CollectUserDataView.js';
export { EmailConfirmationWaitingView } from './lib/views/EmailConfirmationWaitingView/EmailConfirmationWaitingView.js';
export { NoAccess } from './lib/views/NoAccess/NoAccess.js';
export { PendingSignatureView } from './lib/views/PendingSignatureView/PendingSignatureView.js';
export { QrCodeView } from './lib/views/QrCodeView/QrCodeView.js';
export { WalletList } from './lib/views/WalletList/WalletList.js';
export { FarcasterConnectView } from './lib/views/FarcasterConnectView/FarcasterConnectView.js';
export { NetworkNotSupportedSwitchManual } from './lib/views/NetworkNotSupportedSwitchManual/NetworkNotSupportedSwitchManual.js';
export { viewToComponentMap } from './lib/views/viewToComponentMap.js';
export { useDynamicModals } from './lib/utils/hooks/useDynamicModals/useDynamicModals.js';
export { useMfa } from './lib/utils/hooks/useMfa/useMfa.js';
export { useTokenBalances } from './lib/utils/hooks/useTokenBalances/useTokenBalances.js';
export { useEmbeddedWallet } from './lib/utils/hooks/useEmbeddedWallet/useEmbeddedWallet.js';
export { EmbeddedWalletVersion } from './lib/utils/hooks/useEmbeddedWallet/useSecureEnclaveEmbeddedWallet/constants.js';
export { useExternalAuth } from './lib/utils/hooks/useExternalAuth/useExternalAuth.js';
export { useRefreshUser } from './lib/utils/hooks/useRefreshUser/useRefreshUser.js';
export { useWalletOptions } from './lib/utils/hooks/useWalletOptions/useWalletOptions.js';
export { useSyncMfaFlow } from './lib/utils/hooks/useSyncMfaFlow/useSyncMfaFlow.js';
export { useTelegramLogin } from './lib/utils/hooks/useTelegramLogin/useTelegramLogin.js';
export { useUpgradeEmbeddedWallet } from './lib/utils/hooks/useUpgradeEmbeddedWallet/useUpgradeEmbeddedWallet.js';
export { useDeleteUserAccount } from './lib/utils/hooks/useDeleteUserAccount/useDeleteUserAccount.js';
export { DynamicConnectButton } from './lib/components/DynamicConnectButton/DynamicConnectButton.js';
import './lib/components/InlineWidget/InlineWidget.js';
export { IsBrowser } from './lib/components/IsBrowser/IsBrowser.js';
import './lib/components/PasskeyCreatedSuccessBanner/PasskeyCreatedSuccessBanner.js';
import './lib/components/Popper/Popper/Popper.js';
import './lib/components/Popper/PopperContext/PopperContext.js';
import '@dynamic-labs/rpc-providers';
export { DynamicBridgeWidget } from './lib/widgets/DynamicBridgeWidget/DynamicBridgeWidget.js';
export { DynamicEmbeddedAuthFlow } from './lib/widgets/DynamicEmbeddedWidget/DynamicEmbeddedAuthFlow/DynamicEmbeddedAuthFlow.js';
export { DynamicEmbeddedUserProfile } from './lib/widgets/DynamicEmbeddedWidget/DynamicEmbeddedUserProfile/DynamicEmbeddedUserProfile.js';
export { DynamicEmbeddedWidget } from './lib/widgets/DynamicEmbeddedWidget/DynamicEmbeddedWidget.js';
export { DynamicWidget } from './lib/widgets/DynamicWidget/DynamicWidget.js';
export { ShadowedDynamicNav as DynamicNav } from './lib/widgets/DynamicWidget/components/DynamicNav/DynamicNav.js';
export { ShadowedDynamicUserProfile as DynamicUserProfile } from './lib/widgets/DynamicWidget/components/DynamicUserProfile/DynamicUserProfile.js';
export { OnrampWidget as FundingWidget, OnrampWidget } from './lib/widgets/OnrampWidget/OnrampWidget.js';
export { DynamicMultiWalletPromptsWidget } from './lib/widgets/DynamicMultiWalletPromptsWidget/DynamicMultiWalletPromptsWidget.js';
export { getDefaultColor, getThemeConfig, themesData } from './lib/context/ThemeContext/themesData.js';
export { getNetwork } from './lib/utils/functions/getNetwork/getNetwork.js';
export { useFunding } from './lib/utils/hooks/useFunding/useFunding.js';
export { useOnramp } from './lib/utils/hooks/useOnramp/useOnramp.js';
export { useOpenFundingOptions } from './lib/utils/hooks/useOpenFundingOptions/useOpenFundingOptions.js';
export { useSendBalance } from './lib/context/SendBalanceContext/SendBalanceContext.js';
import './lib/context/ConnectWithOtpContext/ConnectWithOtpContext.js';
import './lib/context/ConnectWithOtpContext/constants.js';
export { useConnectWithOtp } from './lib/context/ConnectWithOtpContext/useConnectWithOtp.js';
export { useSwitchNetwork } from './lib/utils/hooks/useSwitchNetwork/useSwitchNetwork.js';
export { useReinitialize } from './lib/context/ReinitializeContext/ReinitializeContextProvider.js';

assertPackageVersion('@dynamic-labs/sdk-react-core', version);
